<template>
  <div class="editor">
    <editor-menu-bar
      v-slot="{ commands, isActive }"
      :editor="editor"
    >
      <div class="menubar">
        <span
          v-for="actionName in activeButtons"
          :key="actionName"
        >
          <button
            v-if="actionName === 'bold'"
            :class="{ 'is-active': isActive.bold() }"
            class="menubar__button"
            @click="commands.bold"
          >
            <editor-icon name="bold" />
          </button>
          <button
            v-if="actionName === 'italic'"
            :class="{ 'is-active': isActive.italic() }"
            class="menubar__button"
            @click="commands.italic"
          >
            <editor-icon name="italic" />
          </button>

          <button
            v-if="actionName === 'underline'"
            :class="{ 'is-active': isActive.underline() }"
            class="menubar__button"
            @click="commands.underline"
          >
            <editor-icon name="underline" />
          </button>

          <button
            v-if="actionName === 'paragraph'"
            :class="{ 'is-active': isActive.paragraph() }"
            class="menubar__button"
            @click="commands.paragraph"
          >
            <editor-icon name="paragraph" />
          </button>

          <button
            v-if="actionName === 'h1'"
            :class="{ 'is-active': isActive.heading({ level: 1 }) }"
            class="menubar__button"
            @click="commands.heading({ level: 1 })"
          >H1</button>

          <button
            v-if="actionName === 'h2'"
            :class="{ 'is-active': isActive.heading({ level: 2 }) }"
            class="menubar__button"
            @click="commands.heading({ level: 2 })"
          >H2</button>

          <button
            v-if="actionName === 'h3'"
            :class="{ 'is-active': isActive.heading({ level: 3 }) }"
            class="menubar__button"
            @click="commands.heading({ level: 3 })"
          >H3</button>

          <button
            v-if="actionName === 'bullet_list'"
            :class="{ 'is-active': isActive.bullet_list() }"
            class="menubar__button"
            @click="commands.bullet_list"
          >
            <editor-icon name="ul" />
          </button>

          <button
            v-if="actionName === 'ordered_list'"
            :class="{ 'is-active': isActive.ordered_list() }"
            class="menubar__button"
            @click="commands.ordered_list"
          >
            <editor-icon name="ol" />
          </button>

          <button
            v-if="actionName === 'horizontal_rule'"
            class="menubar__button"
            @click="commands.horizontal_rule"
          >
            <editor-icon name="hr" />
          </button>

          <button
            v-if="actionName === 'undo'"
            class="menubar__button"
            @click="commands.undo"
          >
            <editor-icon name="undo" />
          </button>

          <button
            v-if="actionName === 'redo'"
            class="menubar__button"
            @click="commands.redo"
          >
            <editor-icon name="redo" />
          </button>
        </span>
      </div>
    </editor-menu-bar>

    <editor-content
      :editor="editor"
      class="editor__content"
    />
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'

import EditorIcon from './EditorIcon.vue'

export default {
  name: 'MainEditor',
  components: {
    EditorContent,
    EditorMenuBar,
    EditorIcon,
  },
  props: {
    initialContent: {
      type: String,
      default: '',
    },
    activeButtons: {
      type: Array,
      validator: function _(list) {
        /* eslint-disable */
        for (let el of list) {
          // The value must match one of these strings
          if (
            [
              'bold',
              'italic',
              'strike',
              'underline',
              'code',
              'paragraph',
              'h1',
              'h2',
              'h3',
              'bullet_list',
              'ordered_list',
              'blockquote',
              'code_block',
              'horizontal_rule',
              'undo',
              'redo'
            ].indexOf(el) === -1
          ) {
            return -1
          }
        }
        return 1
      },
      default: () => ['bold', 'italic'],
      /* eslint-enable */
    },
  },
  data() {
    return {
      html: '',
      json: '',
      editor: new Editor({
        extensions: [
          new BulletList(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        content: this.initialContent || '',
      }),
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  created() {
    this.html = this.editor.getHTML()
    this.json = this.editor.getJSON()
    this.editor.on('update', () => {
      this.html = this.editor.getHTML()
      this.json = this.editor.getJSON()
      this.$emit('update', this.html)
    })
  },
}
</script>

<style lang="scss" scoped>
.editor__content {
  border-radius: 4px;
  border: 1px solid #d6d6d6;
}
</style>
